import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage1 from "./pages/HomePage1";
import ScrollToTop from "./components/ScrollToTop";
import "./styles/tokens.css";
import "./styles/globals.css";
import "./styles/v2.css";
import "./styles/media-components.css";
import "./styles/prototype-pages.css";
import "./styles/pages/work.css";

const WorkPage = React.lazy(() => import("./pages/WorkPage4"));
const LeadershipPage = React.lazy(() => import("./pages/LeadershipPage"));
const AboutPage = React.lazy(() => import("./pages/AboutPage"));
const PlaygroundPage = React.lazy(() => import("./pages/PlaygroundPage"));
const NotFoundPage = React.lazy(() => import("./pages/NotFoundPage"));

const RouteLoadingFallback = () => (
  <div
    aria-label="Loading page"
    aria-live="polite"
    className="route-loading"
    role="status"
  />
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <ScrollToTop />
        <main>
          <React.Suspense fallback={<RouteLoadingFallback />}>
            <Routes>
              <Route path="/" element={<HomePage1 />} />
              <Route
                path="/work"
                element={<Navigate to="/work/cooperators" replace />}
              />
              <Route path="/work/:transformationId" element={<WorkPage />} />
              <Route
                path="/work/:transformationId/:caseStudyId"
                element={<WorkPage />}
              />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/leadership" element={<LeadershipPage />} />
              {process.env.NODE_ENV === "development" && (
                <Route path="/playground" element={<PlaygroundPage />} />
              )}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </React.Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
